module.exports = __webpack_public_path__ + "img/multi-m-logo.45915a7a.png";